import { render, staticRenderFns } from "./StatisticsCard.vue?vue&type=template&id=10999d2e&scoped=true"
import script from "./StatisticsCard.vue?vue&type=script&lang=js"
export * from "./StatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./StatisticsCard.vue?vue&type=style&index=0&id=10999d2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10999d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10999d2e')) {
      api.createRecord('10999d2e', component.options)
    } else {
      api.reload('10999d2e', component.options)
    }
    module.hot.accept("./StatisticsCard.vue?vue&type=template&id=10999d2e&scoped=true", function () {
      api.rerender('10999d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/StatisticsCard.vue"
export default component.exports